import AppConstants from 'constants/AppConstants';

interface State {
  showConsumerMenu: boolean;
  showNavSearch: boolean;
  showConfirmSelectionDialog: boolean;
  showLoyaltyProgramLoginModal: boolean;
}

const initialState: State = {
  showConsumerMenu: false,
  showNavSearch: false,
  showConfirmSelectionDialog: false,
  showLoyaltyProgramLoginModal: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.MENU_CLOSE: {
      return {
        ...state,
        showConsumerMenu: false,
      };
    }

    case AppConstants.MENU_TOGGLE: {
      return {
        ...state,
        showConsumerMenu: payload,
      };
    }

    case AppConstants.NAV_SEARCH_TOGGLE: {
      return {
        ...state,
        showNavSearch: !state.showNavSearch,
      };
    }

    case AppConstants.CLOSE_LOYALTY_PROGRAM_LOGIN_MODAL: {
      return {
        ...state,
        showLoyaltyProgramLoginModal: false,
      };
    }

    case AppConstants.OPEN_LOYALTY_PROGRAM_LOGIN_MODAL: {
      return {
        ...state,
        showLoyaltyProgramLoginModal: true,
      };
    }

    case AppConstants.CONFIRM_SELECTION_SET_DIALOG_VISIBILE: {
      return {
        ...state,
        showConfirmSelectionDialog: payload,
      };
    }

    default:
      return state;
  }
}
